module.exports = __webpack_public_path__ + "static/media/menu.c74f6b57.svg";